import React from 'react';
import fakeProfilesService from '../services/fakeProfilesService';
import VisitcardComponent from './StateLessComponents/VisitcardComponent';

class CellarComponent extends React.Component {
    constructor(props) {
        super(props);

        const path = "/images/neustadtfunken/keller";

        this.state = {
            kuehlhaus: { name: "Kühlhaus", path: path + "/keller3.jpg" },

            row1: [
                { name: "Sitzbereich", path: path + "/Bild 11.jpg" },
                { name: "Theke", path: path + "/Bild 12.jpg" },
                { name: "Steh- / Tanzfläche", path: path + "/Bild 15.jpg" },
                { name: "Flur", path: path + "/Bild 18.jpg" },
                { name: "Küche", path: path + "/Bild 19.jpg" },
            ],

            row2: [
                { name: "Gesamtraum", path: path + "/keller1.jpg" },
                { name: "Leinwand und Beamer", path: path + "/keller2.jpg" },
                { name: "Weiterer Raum", path: path + "/keller4.jpg" },
                { name: "Eingangsbereich", path: path + "/keller5.jpg" },
            ],

            rent: []
        }
    }

    async componentDidMount() {
        const rent = await fakeProfilesService.getProfiles({ filter: p => { return p.email === "kellervermietung@kgneustadtfunken.de" } });

        this.setState({ rent });
    }

    render() {
        const { kuehlhaus, row1, row2, rent } = this.state;

        return (
            <div>
                <h1 className='kgnsf-header'>Der Funkenkeller - unser Zuhause in Rot und Weiss</h1>

                <blockquote className='kgnsf-blockquote'>
                    <p>Im Herzen von Opladen befindet sich unser Funkenkeller, hier wird nicht nur während der Session gefeiert, getanzt und gelacht.</p>
                    <p>Wenn wir nicht selbst feiern, stellen wir den Funkenkeller gerne zur Vermietung bereit. Egal ob Taufe, Geburtstag, Hochzeit, Jubiläum oder Weihnachtsfeier - der Funkenkeller bietet das perfekte Ambiente für jede Feier.</p>
                    <p>Neben einer komplett ausgestatteten Küche und einer Musikanlage, verfügt der Funkenkeller über einen Beamer mit Leinwand, Internetzugang, Lichtanlage, Kühlhaus sowie einem weiteren Buffetraum.</p>
                    <p>Um das Paket abzurunden stellen wir das Thekenpersonal zur Verfügung, so dass Sie Ihre Feier in vollen Zügen genießen können.</p>
                </blockquote>

                <div className='row'>
                    {row1?.map((img, index) => {
                        return (
                            <div key={img.key + index} className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                                <img alt="" className='img-fluid kgnsf-img' src={img.path} />
                                <p className='kgnsf-img-title'>{img.name}</p>
                            </div>
                        )
                    })}
                </div>

                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img alt="" className='img-fluid kgnsf-img' src={kuehlhaus.path} />
                        <p className='kgnsf-img-title'>{kuehlhaus.name}</p>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        {row2?.map(img => {
                            return (
                                <div key={img.key} className='col-12'>
                                    <img alt="" className='img-fluid kgnsf-img' src={img.path} />
                                    <p className='kgnsf-img-title'>{img.name}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className='row justify-content-end'>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        {rent && <VisitcardComponent title="Bei Fragen / Interesse" profiles={rent}></VisitcardComponent>}
                    </div>
                </div>
            </div>
        )
    }
}

export default CellarComponent;